import Session from 'app/interface/redux/types/core/session'

const DefaultSession: Session = {
  active: false,
  ready: false,
}

export default DefaultSession
